import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useTranslations } from "@src/packages/i18n";
import type { YouStackParamList } from "../../../types";
import Integrations from "../sections/Integrations";
import YouDetailScreenLayout from "../components/YouDetailScreenLayout";
import { useSmartBack } from "../../../hooks/useSmartBack";

type Props = NativeStackScreenProps<YouStackParamList, "IntegrationsSettings">;

export default function IntegrationsSettingsScreen(_props: Props) {
  const handleBack = useSmartBack({
    fallbackTab: "Profile",
    fallbackScreen: "YouOverview",
  });
  const t = useTranslations();

  return (
    <YouDetailScreenLayout
      title={t("you.panel_titles.integrations")}
      onBack={handleBack}
    >
      <Integrations />
    </YouDetailScreenLayout>
  );
}
